import { getAdvertiserExts, getAwemes, getProductDetails, getProducts, getTitleGroups, getAdvertiserInfo, getPlatforms, getPtFenxiaos, getKvData, getAdminTeams, verifyMediaCorporations } from '@/api/open'
import { storeOrUpdateAdTask } from '@/api/ad-task'
import moment from 'moment'
import NoBSGS from './District'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import VideoSelect from '@/components/video-select/VideoSelect.vue'
import VideoRankSelect from '@/components/video-rank-select/VideoRankSelect.vue'
import OrgVideoSelect from '@/components/org-video-select/OrgVideoSelect.vue'
import CodeInput from '@/components/code-input/CodeInput.vue'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import { pullAnchor, syncLandingPage, pullWechatApp, pullEventAsset} from '@/api/advertiser'
import TitleGroup from '@/components/title-group/TitleGroup.vue'
import MaterialPullSelect from '@/components/material-pull-select/MaterialPullSelect.vue'

export default {
    components: {
        MaterialSelect,
        VideoSelect,
        CodeInput,
        AdvSelect,
        TitleGroup,
        VideoRankSelect,
        MaterialPullSelect,
        OrgVideoSelect,
        // UploadForm,
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        media: {
            type: String,
            required: true
        },
        showCreateForm: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            select_ldy_url:null,
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            advs: {},
            ldy_type:1, //落地页类型：1-账户选择 2-自定义
            model: {
                ids: [],
                name: '',
                landing_type: 'MICRO_GAME',
                classify: 'CLASSIFY_INTERNAL',
                marketing_goal: 'VIDEO_AND_IMAGE',
                delivery_mode: 'PROCEDURAL',
                ad_type: 'ALL',
                micro_promotion_type: 'AWEME',
                optimize_goal: {
                    external_action: 'AD_CONVERT_TYPE_PAY',
                    deep_external_action: null,
                    asset_ids: null,
                   
                },
                delivery_range: {
                    inventory_catalog: 'MANUAL',
                    inventory_type: ['INVENTORY_AWEME_FEED'],
                },
                audience: {
                    district: 'NONE',
                    gender: 'NONE',
                    age: ['BUDGET_MODE_INFINITE'],
                    platform: [''],
                    interest_action_mode: 'UNLIMITED',
                },
                delivery_setting: {
                    schedule_type: 'SCHEDULE_FROM_NOW',
                    schedule_time_type: 1, //投放时间段类型
                    schedule_time: [], //投放时间段
                    schedule_date: [], //开始和结束日期
                    bid_type: 'CUSTOM',
                    budget_mode: 'BUDGET_MODE_INFINITE',
                    pricing: 'PRICING_OCPM',
                    budget_optimize_switch: 'OFF',
                    deep_bid_type: 'ROI_COEFFICIENT'
                },
                related_product: {
                    product_setting: 'SINGLE',
                    product_id: '',
                },
                search_bid_ratio: 1.05,
                cpa_bid: null, //出价
                roi_goal: null, //roi系数
                audience_extend: 'OFF',
                operation: 'ENABLE',
                ad: {
                    num: 1,
                    title_num:10,
                    material_rule:2,
                    material_num:1,
                    name: '',
                    source: '蛋花短剧',
                    native_setting: {
                        anchor_related_type: 'AUTO',
                        aweme_id: null
                    },
                    promotion_materials: {
                        call_to_action_buttons: ['点击观看', '继续观看', '看全集', '下一集', '精彩继续'],
                        title_material_list: [],
                        product_info: {
                            titles: '蛋花短剧',
                            image_ids: [],
                            selling_points: ['超热门火爆短剧', '必看热门短剧', '今天不看后悔一年', '超火爆热门漫剧', '必看热门漫剧']
                        },
                    },
                    is_comment_disable: 'OFF',
                    video_ids: [],
                    video_ids_local: [],
                    video_ids_rank: [],
                    video_ids_org: [],
                    bid_model: 1, //广告出价模式： 1-统一 2-分别
                    roi_goal_model: 1, //广告ROI系数模式 1-统一 2-分别
                    video_hp_visibility: "HIDE_VIDEO_ON_HP", //设置主页可见性 主页始终可见-ALWAYS_VISIBLE; 仅单次展示可见-HIDE_VIDEO_ON_HP
                    generate_mode: false,
                    ad_name_model: 1,//广告名称模式 1-统一 2-分别
                    source_model: 1,//来源模式 1-统一 2-分别
                },
                product_model: 1, //商品库模式： 1-统一 2-分别
                cpa_bid_model: 1, //项目出价模式 1-统一 2-分别
                roi_goal_model: 1, //项目ROI系数模式 1-统一 2-分别
                project_name_model: 1, //项目名称模式 1-统一 2-分别
                material_type: 1,
                need_product: 1,
            },
            promotionTypes: [
                { id: 'AD_CONVERT_TYPE_ACTIVE', name: '激活', disabled: false },
                { id: 'AD_CONVERT_TYPE_PAY', name: '付费', disabled: false },
                { id: 'AD_CONVERT_TYPE_GAME_ADDICTION', name: '关键行为', disabled: false },
                { id: 'AD_CONVERT_TYPE_CLICK_NUM', name: '点击量', disabled: true },
                { id: 'AD_CONVERT_TYPE_SHOW_OFF_NUM', name: '展示量', disabled: true }
            ],
            deepPromotionTypes: [
                { id: 'AD_CONVERT_TYPE_PURCHASE_ROI', name: '付费ROI'},
                { id: 'AD_CONVERT_TYPE_LT_ROI', name: '广告变现ROI'},
            ],
            inventoryTypes: [
                { id: 'INVENTORY_FEED', name: '今日头条', disabled: false },
                { id: 'INVENTORY_VIDEO_FEED', name: '西瓜视频', disabled: false },
                { id: 'INVENTORY_AWEME_FEED', name: '抖音短视频', disabled: false },
                { id: 'INVENTORY_TOMATO_NOVEL', name: '番茄小说', disabled: false },
                { id: 'INVENTORY_UNION_SLOT', name: '穿山甲', disabled: false },
                { id: 'UNION_BOUTIQUE_GAME', name: 'ohayoo精品游戏', disabled: false },
            ],
            ages: [
                { id: 'BUDGET_MODE_INFINITE', name: '不限' },
                { id: 'AGE_BETWEEN_18_23', name: '18-23' },
                { id: 'AGE_BETWEEN_24_30', name: '24-30' },
                { id: 'AGE_BETWEEN_31_40', name: '31-40' },
                { id: 'AGE_BETWEEN_41_49', name: '41-49' },
                { id: 'AGE_ABOVE_50', name: '50+' },
            ],
            platforms: [
                { id: '', name: '不限' },
                { id: 'ANDROID', name: 'Android' },
                { id: 'IOS', name: 'iOS' },
            ],
            bidTypes: [
                { id: 'CUSTOM', name: '稳定成本' },
                { id: 'UPPER_CONTROL', name: '最优成本' },
                { id: 'NO_BID', name: '最大转化' },
            ],
            bidTypes2: [
                { id: 'CUSTOM', name: '稳定成本' },
                { id: 'NO_BID', name: '最大转化' },
            ],
            buttons: [
                '点击观看',
                '继续观看',
                '看全集',
                '下一集',
                '精彩继续',
            ],
            sellingPoints: [
                '超热门火爆短剧',
                '必看热门短剧',
                '今天不看后悔一年',
                '超火爆热门漫剧',
                '必看热门漫剧',
            ],
            products: [],
            productDetails: {},
            awemes: [],
            corporations: [],
            loading: false,
            syncLoading: false,
            actionName: '操作',
            timeout: null,
            rules: {
                'ids': [{ required: true, message: '请选择广告主', trigger: 'change' }],
                'team_id': [{ required: true, message: '请选择所属小组', trigger: 'change' }],
                'related_product.product_platform_id': [{ required: true, message: '请选择关联商品库', trigger: 'change' }],
                'related_product.product_id': [{ required: true, message: '请选择关联产品', trigger: 'change' }],
                'optimize_goal.external_action': [{ required: true, message: '请选择优化目标', trigger: 'change' }],
                'delivery_setting.deep_bid_type': [{ required: true, message: '请选择深度优化方式', trigger: 'change' }],
                'delivery_setting.schedule_date': [{ required: true, message: '请选择投放开始和结束时间', trigger: 'change' }],
                'delivery_setting.schedule_time_type': [{ required: true, message: '请选择投放时间段类型', trigger: 'change' }],
                'delivery_setting.schedule_time': [{ required: true, message: '请选择投放时间段', trigger: 'change' }],
                'delivery_setting.bid_type': [{ required: true, message: '请选择竞价策略', trigger: 'change' }],
                'delivery_range.inventory_type': [{ required: true, message: '请选择首选媒体', trigger: 'change' }],
                'name': [{ required: true, message: '请输入项目名称', trigger: 'change' }],
                'cpa_bid': [{ required: true, message: '请输入出价', trigger: 'change' }],
                'roi_goal': [{ required: true, message: '请输入ROI系数', trigger: 'change' }],
                'ad.roi_goal': [{ required: true, message: '请输入ROI系数', trigger: 'change' }],
                'ad.native_setting.aweme_id': [{ required: true, message: '请选择抖音号', trigger: 'change' }],
                'ad.native_setting.anchor_related_type': [{ required: true, message: '请选择原生锚点类型', trigger: 'change' }],
                'ad.video_ids': [{ required: true, message: '请选择账户视频素材', trigger: 'change' }],
                'ad.video_ids_local': [{ required: true, message: '请选择本地视频素材', trigger: 'change' }],
                'ad.video_ids_rank': [{ required: true, message: '请选择视频排行素材', trigger: 'change' }],
                'ad.video_ids_org': [{ required: true, message: '请选择组织素材', trigger: 'change' }],
                'ad.promotion_materials.title_material_list': [{ required: true, message: '请选择文案素材标题', trigger: 'change' }],
                'ad.promotion_materials.product_info.titles': [{ required: true, message: '请输入产品名称', trigger: 'change' }],
                'ad.promotion_materials.product_info.image': [{ required: true, message: '请选择产品主图', trigger: 'change' }],
                'ad.promotion_materials.product_info.selling_points': [{ required: true, message: '请输入产品卖点', trigger: 'change' }],
                'ad.promotion_materials.call_to_action_buttons': [{ required: true, message: '请输入行动号召', trigger: 'change' }],
                'ad.source': [{ required: true, message: '请输入来源', trigger: 'change' }],
                'ad.budget': [{ required: true, message: '请输入广告预算', trigger: 'change' }],
                'ad.bid': [{ required: true, message: '请输入广告出价', trigger: 'change' }],
                'ad.name': [{ required: true, message: '请输入广告名称', trigger: 'change' }],
                'ad.num': [{ required: true, message: '请输入广告数量', trigger: 'change' }],
                'ad.title_num': [{ required: true, message: '请输入广告文案标题数量', trigger: 'change' }],
                'ad.material_num': [{ required: true, message: '请输入广告素材数量', trigger: 'change' }],
                'platform_id': [{ required: true, message: '请选择平台', trigger: 'change' }],
                'classify': [{ required: false, message: '请选择项目类别', trigger: 'change' }],
            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            currentAdvId: null,
            current: 0,
            steps: [
                { title: '创建项目' },
                { title: '广告设置' },
                { title: '关联设置' },
                { title: '任务结果' },
            ],
            titleGroups: [],
            selectedEventConfigs: [],
            selectedAppLinks: [],
            adBudget: 300, //最大预算
            material_type: 1, //视频素材类型： 1-账户素材 2-本地素材 3-素材排行
            visible: false,
            confirmLoading: false,
            bid_limit: null, //出价限制
            bid_suggest: null, //出价推荐
            sources: [
                // '抖音视界',
                '晔彗网络科技',
                '点众快看',
                // '沈阳昊嘟信息',
                '七猫文化',
                // '百分信百科技',
                // '每日剧场',
                // '沁黛剧场',
                '嘉兴飞杰',
                '大连剧鸣',
                '长沙烟若',
                '蛋花短剧',
            ],
            product_titles: [
                '超热门火爆短剧',
                '热播短剧',
                '全程高能,处处精华',
                '必看热门短剧',
                '今天不看后悔一年',
                '蛋花短剧',
            ],
            prefixArray: [
                '五六-roi高', 
                '五六-roi低', 
                '五六-roi超低', 
                '五四-roi高', 
                '五四-roi低', 
                '五四-roi超低',
            ],
            prefixArray2: [
                '大量-五六-IAA高',
                '大量-五六-IAA低',
                '大量-五六-IAA超低',
                '大量-五六-IAA超超低',
                '侠-烟若iaa-roi1',
                '侠-烟若iaa-roi2',
                '侠-烟若iaa-roi3',
                '侠-IAA-长沙旋芹',
            ],
            externalUrls: [],
            baseAdv: {},
            advertisers: [], //广告主
            remind: "（该主体未提报限价，系统默认10元）",
            activeTabKey: null,
            batch_external_url: null,
            batch_video_url: '',
            advertiserInfo: {},
            showProduct: true,
            showInventoryType: false,
            videoUrls: [],
            newPlatforms: {},
            adminTeams: {},
            ptFenxiaos: {}, 
            kvDatas: {},
            roiDefaultLimits: {},
            maxAdNum: 10,
            adNumHelp: '每个账户要生成的广告数量，最大不能超过10个',
            selectedAdvIds: [],
            // showUploadForm: false, 
            videoLoading: false,
            searchKeyword: '',
            searchTimer: null,
            materialSearchMode: 1,
            classifySwitch: true, //内广开关，默认开启
        }
    },
    computed: {
        showClassify() {
            return !!this.params.classify
        },
        actType() {
            return this.model.id ? '修改' : '新建'
        },
        // 选择优分配 ON  全部不显示
        // 选择优分配 OFF 显示预算
        showAdBid() {
            if (this.model.delivery_setting.bid_type !== 'NO_BID') {
                return true
            }
            return false
        },
        showAdBudge() {
            if (this.model.delivery_setting.bid_type !== 'NO_BID') {
                return true
            }
            return this.model.delivery_setting.budget_optimize_switch === 'OFF'
        },
        maxVideoNum() {
            const materialNum = this.model.ad.material_num || 1
            return materialNum * 10
        },
        currentVideoCount() {
            if (this.material_type === 1) {
                return this.model.ad.video_ids ? this.model.ad.video_ids.length : 0
            } else if (this.material_type === 2) {
                return this.model.ad.video_ids_local ? this.model.ad.video_ids_local.length : 0
            } else if (this.material_type === 3) {
                return this.model.ad.video_ids_rank ? this.model.ad.video_ids_rank.length : 0
            } else if (this.material_type === 4) {
                return this.model.ad.video_ids_org ? this.model.ad.video_ids_org.length : 0
            }
            return 0
        },
    },
    mounted() {
        // console.log('this.params.params.start', this.params.params)
        // console.log('this.showClassify', this.showClassify)
        if (this.params.params) {
            if (this.showClassify === false) {
                this.params.params.classify = null
            }

            if (!this.params.params.optimize_goal.deep_external_action) {
                this.params.params.optimize_goal.deep_external_action = null
            }
            
            //清除项目出价
            if (this.params.params.cpa_bid) {
                this.params.params.cpa_bid = null
            }
            //清除广告出价
            if (this.params.params.ad && this.params.params.ad.bid) {
                this.params.params.ad.bid = null
            }

            if (!this.params.params.ad.title_num) {
                this.params.params.ad.title_num = 10
            }

            if (!this.params.params.ad.material_rule) {
                this.params.params.ad.material_rule = 2
            }
            if (!this.params.params.ad.material_num) {
                this.params.params.ad.material_num = 3
            }
            if (!this.params.params.ad.promotion_materials) {
                this.params.params.ad.promotion_materials = {
                    call_to_action_buttons: ['点击观看', '继续观看', '看全集', '下一集', '精彩继续'],
                    title_material_list: [],
                    product_info: {
                        titles: '蛋花短剧',
                        image_ids: [],
                        selling_points: ['超热门火爆短剧', '必看热门短剧', '今天不看后悔一年', '超火爆热门漫剧', '必看热门漫剧']
                    },
                }
            } else {
                if (!this.params.params.ad.promotion_materials.product_info) {
                    this.params.params.ad.promotion_materials.product_info = {
                        titles: '蛋花短剧',
                        image_ids: [],
                        selling_points: ['超热门火爆短剧', '必看热门短剧', '今天不看后悔一年', '超火爆热门漫剧', '必看热门漫剧']
                    }
                } else {
                    if (!this.params.params.ad.promotion_materials.product_info.titles) {
                        this.params.params.ad.promotion_materials.product_info.titles = '蛋花短剧'
                    }
                    if (!this.params.params.ad.promotion_materials.product_info.selling_points || this.params.params.ad.promotion_materials.product_info.selling_points.length === 0) {
                        this.params.params.ad.promotion_materials.product_info.selling_points = ['超热门火爆短剧', '必看热门短剧', '今天不看后悔一年', '超火爆热门漫剧', '必看热门漫剧']
                    }
                }
                if (!this.params.params.ad.promotion_materials.call_to_action_buttons || this.params.params.ad.promotion_materials.call_to_action_buttons.length === 0) {
                    this.params.params.ad.promotion_materials.call_to_action_buttons = ['点击观看', '继续观看', '看全集', '下一集', '精彩继续']
                }
            }
            if (!this.params.params.ad.source) {
                this.params.params.ad.source = '蛋花短剧'
            }
            if (!this.params.params.operation) {
                this.params.params.operation = 'ENABLE'
            }
            if (!this.params.params.delivery_setting.schedule_date) {
                this.params.params.delivery_setting.schedule_date = []
            }

            if (!this.params.params.delivery_setting.schedule_time_type) {
                this.params.params.delivery_setting.schedule_time_type = 1
            }

            // console.log('this.params.params.delivery_setting.schedule_time', this.params.params.delivery_setting.schedule_time)
            if (!this.params.params.delivery_setting.schedule_time) {
                this.params.params.delivery_setting.schedule_time = []
            } else {
                this.params.params.delivery_setting.schedule_time = this.params.params.delivery_setting.schedule_time.map(item => {
                    return !item? []: item
                })
            }
            // console.log('this.params.params.delivery_setting', this.params.params.delivery_setting)

            // this.params.params.need_product = 1 

            if (this.params.params.delivery_mode == 'PROCEDURAL' && this.params.params.delivery_setting.bid_type == 'UPPER_CONTROL') {
                this.params.params.delivery_setting.bid_type = null
            }

            this.params.params.product_model = this.params.params.product_model ?? 1
            this.params.params.ad.bid_model = this.params.params.ad.bid_model ?? 1
            this.params.params.ad.roi_goal_model = this.params.params.ad.roi_goal_model ?? 1
            this.params.params.roi_goal_model = this.params.params.roi_goal_model ?? 1
            this.params.params.cpa_bid_model = this.params.params.cpa_bid_model ?? 1
            this.params.params.project_name_model = this.params.params.project_name_model ?? 1
            this.params.params.ad.ad_name_model = this.params.params.ad.ad_name_model ?? 1
            this.params.params.ad.source_model = this.params.params.ad.source_model ?? 1
            if (!this.params.params.ad.video_ids_rank) {
                this.params.params.ad.video_ids_rank = []
            }
            if (!this.params.params.ad.video_ids_org) {
                this.params.params.ad.video_ids_org = []
            }
            if (!this.params.params.ad.native_setting.aweme_id) {
                this.params.params.ad.native_setting.aweme_id = null
            }

            if (!this.params.params.ad.generate_mode) {
                // 设置主页可见性：默认仅单次展示可见
                this.params.params.ad.video_hp_visibility = "HIDE_VIDEO_ON_HP"
            }

            // 根据 classify 值初始化内广开关
            this.classifySwitch = this.params.params.classify === 'CLASSIFY_INTERNAL'

            // 这里处理隐藏商品库关联信息
            if (this.params.params.micro_promotion_type === 'AWEME') {
                this.showProduct = false
                this.showInventoryType = true
            }

            // console.log(this.params.params)
            this.model = Object.assign({}, this.$helper.deepClone(this.params.params))
            if (!this.model.delivery_mode) {
                this.model.delivery_mode = 'MANUAL'
            }

          
            this.$set(this.model, 'ids', this.params.advertiser_ids)
            this.init()
        } else if (this.params.ids) {
            this.$set(this.model, 'ids', this.params.ids)
            this.init()
        }

        // console.log('model', this.model)

        const awemeNum = this.model.ad?.native_setting?.aweme_id?.length || 0
        if (awemeNum > 1 && this.model.ad.generate_mode) {
            this.maxAdNum = awemeNum
            this.adNumHelp = '多抖音号+启用生成模式，最大广告数量不能超过'+awemeNum+'个'
        }

        if (this.model.ad.video_ids_local && this.model.ad.video_ids_local.length>0) {
            this.material_type = 2
        } else if (this.model.ad.video_ids_rank && this.model.ad.video_ids_rank.length>0) {
            this.material_type = 3
        } else if (this.model.ad.video_ids_org && this.model.ad.video_ids_org.length>0) {
            this.material_type = 4
        } else {
            this.material_type = 1
        }

        getTitleGroups().then(res => { this.titleGroups = res.data.list || [] })
        this.model.name = '小程序项目' + moment().format('_MM_DD_HH:mm:ss')
        this.syncAdName()
        if (this.model.delivery_mode === 'PROCEDURAL') {
            this.model.delivery_setting.budget_mode = 'BUDGET_MODE_DAY'
        }

        if (this.model.ad.video_ids) {
            this.model.ad.video_ids = this.model.ad.video_ids.filter(item => {
                // 确保 item 包含 width 和 height 属性
                if (!item.width || !item.height) {
                    return false;
                }
                // return true
                // // 计算比例
                const ratio = item.width / item.height;
                // 检查比例是否等于 0.5625 或 1.7778（四舍五入保留4位小数）
                const ratioRounded = Number(ratio.toFixed(4));
                return ratioRounded === 0.5625 || ratioRounded === 1.7778;
            });
        }
        

        if (this.model.delivery_mode === 'PROCEDURAL') {
            this.model.audience.interest_action_mode = 'UNLIMITED'
        }
        getPlatforms({app_type:3,status:1}).then(res => { this.newPlatforms = res.data.list || {}  })
        getKvData({type:7}).then(res => { this.kvDatas = res.data || {} })
        getKvData({type:8}).then(res => { this.roiDefaultLimits = res.data || {} })
        getAdminTeams().then(res => { this.adminTeams = res.data.list || {} })
        this.inputLimit()

       
    },
    watch: {
        currentVideoCount() {
            this.calcAdNum()
        },
        'model.ad.material_num'() {
            this.calcAdNum()
        },
        'model.ad.video_ids'(val) {
            if (val && val.length > 0) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate('ad.video_ids')
                    }
                })
            }
        },
        'model.ad.video_ids_local'(val) {
            if (val && val.length > 0) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate('ad.video_ids_local')
                    }
                })
            }
        },
        'model.ad.video_ids_rank'(val) {
            if (val && val.length > 0) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate('ad.video_ids_rank')
                    }
                })
            }
        },
        'model.ad.video_ids_org'(val) {
            if (val && val.length > 0) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate('ad.video_ids_org')
                    }
                })
            }
        },
        materialSearchMode() {
            this.model.ad.video_ids = []
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate('ad.video_ids')
                }
            })
        },
    },
    created() {},
    methods: {
        changeAdvs() {
            // 更换广告主时，清空数组
            this.advertisers = []
            this.model.advertisers = []
            this.$nextTick(() => {
                if (this.currentAdvId !== this.model.ids[0]) {
                    this.$set(this.model, 'related_product', {
                        product_setting: 'SINGLE',
                        product_id: '',
                    })
                }
            })
            this.$nextTick(this.init)
        },
        init() {
            const refreshProduct = this.currentAdvId !== this.model.ids[0]
            const advertiserFilter = { advertiser_id: this.model.ids[0] }
            this.currentAdvId = this.model.ids[0]
            if (this.model.ids.length === 0) {
                return false
            }
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []
                let k = 0;
                for (const key in this.advs) {
                    const adv = this.advs[key]
                    this.selectedEventConfigs[adv.out_id] = adv.event_configs
                    this.selectedAppLinks[adv.out_id] = adv.micro_app_links
                    if (this.params && this.params.params && this.params.params.advs && this.params.params.advs[key]) {
                        const thisAd = this.params.params.advs[key]
                        if (thisAd.external_url && thisAd.external_url!=adv.external_url) {
                            adv.external_url = thisAd.external_url
                        }
                        if (thisAd.video_url) {
                            adv.video_url = thisAd.video_url
                        }
                    }
                    if (k === 0) {
                        // console.log(adv, adv.bid_limit, adv.bid_suggest)
                        this.bid_limit = adv.bid_limit
                        this.bid_suggest = adv.bid_suggest
                        this.baseAdv = adv
                    }
                    k++

                    // 这里将adv.external_url，塞入addUniqueExternalUrl并去重
                    this.addUniqueExternalUrl(adv.external_url)

                    this.addUniqueVideoUrl(adv.video_url)

                    const advertisers = this.model.advertisers || [];
                    const existingAdvertiser = advertisers.find(item => item.id === adv.id)

                    // let minRoi = this.getRoiMin()
                    
                    // 这里将广告主分别设置的数据塞入
                    const advertiserData = {
                        id: adv.id,
                        advertiser_id: adv.out_id,
                        name: adv.name,
                        product_platform_id: existingAdvertiser ? existingAdvertiser.product_platform_id : null,
                        product_id: existingAdvertiser ? existingAdvertiser.product_id : null,
                        bid: null,//清除广告出价
                        bid_limit: adv.bid_limit,
                        bid_suggest: adv.bid_suggest,
                        // roi_goal: existingAdvertiser ? (existingAdvertiser.roi_goal < minRoi ? minRoi : existingAdvertiser.roi_goal) : null,
                        roi_goal: existingAdvertiser && existingAdvertiser.roi_goal ? (existingAdvertiser.roi_goal != 0.01 ? existingAdvertiser.roi_goal : null) : null,
                        cpa_bid: null,//清除项目出价
                        product_setting: existingAdvertiser ? existingAdvertiser.product_setting : 'SINGLE',
                        project_name: existingAdvertiser ? existingAdvertiser.project_name : null,
                        ad: {
                        //   roi_goal: existingAdvertiser ? (existingAdvertiser.ad.roi_goal < minRoi ? minRoi : existingAdvertiser.ad.roi_goal) : null
                          roi_goal: existingAdvertiser && existingAdvertiser.ad.roi_goal ? (existingAdvertiser.ad.roi_goal != 0.01 ? existingAdvertiser.ad.roi_goal : null) : null,
                          ad_name: existingAdvertiser ? existingAdvertiser.ad.ad_name : null,
                          source: existingAdvertiser ? existingAdvertiser.ad.source : null,
                        }
                    }
                    this.addUniqueAdvertisers(advertiserData)
                }
                // console.log('this.advertisers', this.advertisers)

                // this.model.advertisers = this.advertisers
                // this.generateRules()

                this.changeExternalAction()

                if (this.mediaCorporationCheck(1)) {
                    this.model.optimize_goal.external_action = 'AD_CONVERT_TYPE_PAY'
                    this.model.optimize_goal.deep_external_action = 'AD_CONVERT_TYPE_PURCHASE_ROI'
                } else if (this.mediaCorporationCheck(2)) {
                    this.model.optimize_goal.external_action = null
                    this.model.optimize_goal.deep_external_action = null
                }
            })

            if (refreshProduct) {
                this.loading = true
                //此处需要根据不同的模式初始化商品库
                if (this.model.product_model == 2) {
                    let advertiserId = this.model.ids[0]
                    let modelAdvertiser = this.model.advertisers.find(ad => ad.id === advertiserId)
                    let productPlatformId = null
                    let productId = null
                    if (modelAdvertiser) {
                        productPlatformId = modelAdvertiser.product_platform_id
                        productId = modelAdvertiser.product_id
                    }
                    getProducts({ advertiser_id: advertiserId}).then(res => {
                        this.products[advertiserId] = res.data.list || []
                    }).finally(() => {
                        this.loading = false
                    })
                    if (productId > 0) {
                        this.getProductDetails(advertiserId, productPlatformId)
                    }
                    // 默认选中商品库模式-分别设置第一个广告主
                    this.activeTabKey = advertiserId
                } else {
                    getProducts(advertiserFilter).then(res => {
                        this.products[this.model.ids[0]] = res.data.list || []
                    }).finally(() => {
                        this.loading = false
                    })
                    if (this.model.related_product.product_id > 0) {
                        this.getProductDetails(this.model.ids[0], this.model.related_product.product_platform_id)
                    }
                }
                // 获取广告主绑定的抖音号并赋值
                this.getAwemeId(advertiserFilter)
            }

            // console.log(this.bid_limit, this.bid_suggest)

        },
        refreshProducts(adv_id = null, product_platform_id = null, product_id = null) {
            let advertiser_id = adv_id == null ? this.model.ids[0] : adv_id

            const advertiserFilter = { advertiser_id: advertiser_id }

            // this.$set(this.model, 'related_product', {
            //     product_setting: 'SINGLE',
            //     product_id: '',
            // })
            this.loading = true
            getProducts(advertiserFilter).then(res => {
                // this.products = res.data.list || []
                let this_adv_id = res.data.list || []
                this.products[advertiser_id] = this_adv_id
                this.$set(this.products, advertiser_id, this_adv_id)
            }).finally(() => {
                this.loading = false
            })
            // if (this.model.related_product.product_id > 0) {
            //     this.getProductDetails()
            // }
            if (product_platform_id > 0) {
                this.getProductDetails(adv_id, product_platform_id, null, product_id)
            }
            // 获取广告主绑定的抖音号并赋值
            this.getAwemeId(advertiserFilter)
        },

        refreshProductDetails(adv_id = null, product_platform_id = null) {
            if (product_platform_id > 0) {
                this.getProductDetails(adv_id, product_platform_id, 'refresh')
            }
        },
        mediaCorporationCheck(type=null) {
            if (!this.advs || this.advs.length === 0 || Object.keys(this.advs).length === 0) {
                return false
            }
            const firstKey = Object.keys(this.advs)[0]; 
            const adv = this.advs[firstKey]; // 获取对应的值
            let res
            if (type === 2) {
                res = this.prefixArray2.some(prefix => adv.name.startsWith(prefix)) ? true : false
            } else if (type === 1) {
                res = this.prefixArray.some(prefix => adv.name.startsWith(prefix)) ? true : false
            } else {
                let newArr =[...this.prefixArray, ...this.prefixArray2] 
                res = newArr.some(prefix => adv.name.startsWith(prefix))? true : false
            }
            return res
        },
        validateBeforeSubmit() {
            let thisMin
            if (this.model.product_model === 2 && this.model.need_product == 1) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.product_platform_id) {
                        return this.$message.error(`请选择广告主[${adv.name}]关联商品库`)
                    }
                    if (!adv.product_id) {
                        return this.$message.error(`请填写广告主[${adv.name}]关联产品`)
                    }
                }
            }
            if (this.model.cpa_bid_model === 2 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && !(this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action==='AD_CONVERT_TYPE_LT_ROI')) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.cpa_bid) {
                        return this.$message.error(`请选择广告主[${adv.name}]出价`)
                    }
                }
            }
            if (this.model.roi_goal_model === 2 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && this.model.optimize_goal.deep_external_action) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.roi_goal) {
                        return this.$message.error(`请填写广告主[${adv.name}]ROI系数`)
                    }
                    thisMin = this.getRoiMin(adv)
                    if (adv.roi_goal < thisMin) {
                        return this.$message.error(`广告主[${adv.name}]ROI系数不能低于${thisMin}`)
                    }
                }
            }
            if (this.model.roi_goal_model === 1 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && this.model.optimize_goal.deep_external_action) {
                thisMin = this.getRoiMin()
                if (!this.model.roi_goal) {
                    return this.$message.error(`请填写统一设置ROI系数`)
                }
                if (this.model.roi_goal < thisMin) {
                    return this.$message.error(`统一设置ROI系数不能低于${thisMin}`)
                }
            }
            if ( this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI' && this.model.roi_goal_model === 1 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' ) {
                if (!this.model.roi_goal) {
                    return this.$message.error(`请选择填写ROI系数`)
                }
            }
            if (this.model.project_name_model === 2) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.project_name) {
                        return this.$message.error(`请填写广告主[${adv.name}]项目名称`)
                    }
                }
            }
            if (this.model.ad.bid_model === 2 && this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type !== 'NO_BID' && !(this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI')) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.bid) {
                        return this.$message.error(`请选择广告主[${adv.name}]广告出价`)
                    }
                }
            }
            if (this.model.ad.roi_goal_model === 2 && this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && ( (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.ad.roi_goal) {
                        return this.$message.error(`请选择广告主[${adv.name}]ROI系数`)
                    }
                    thisMin = this.getRoiMin(adv)
                    if (adv.ad.roi_goal < thisMin) {
                        return this.$message.error(`广告主[${adv.name}]ROI系数不能低于${thisMin}`)
                    }
                }
            }
            if (this.model.ad.roi_goal_model === 1 && this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && ( (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))) {
                thisMin = this.getRoiMin()
                if (!this.model.ad.roi_goal) {
                    return this.$message.error(`请填写统一设置ROI系数`)
                }
                if (this.model.ad.roi_goal < thisMin) {
                    return this.$message.error(`统一设置ROI系数不能低于${thisMin}`)
                }
            }
            if (Array.isArray(this.model.ad.native_setting.aweme_id) && this.model.ad.num < this.model.ad.native_setting.aweme_id.length) {
                return this.$message.error(`广告数量不能小于抖音号数量`)
            }
            if (Array.isArray(this.model.ad.native_setting.aweme_id) && this.model.ad.generate_mode && this.model.ad.num != this.model.ad.native_setting.aweme_id.length) {
                return this.$message.error(`抖音号选择多个并且生成模式启用时，广告数量必须等于抖音号数量`)
            }
            if (this.model.ad.ad_name_model === 2) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.ad.ad_name) {
                        return this.$message.error(`请填写广告主[${adv.name}]广告名称`)
                    }
                }
            }
            if (this.model.ad.source_model === 2) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.ad.source) {
                        return this.$message.error(`请填写广告主[${adv.name}]来源`)
                    }
                }
            }
            if (this.material_type === 1) {
                if (!this.model.ad.video_ids || this.model.ad.video_ids.length === 0) {
                    return this.$message.error('请选择账户视频素材')
                }
            } else if (this.material_type === 2) {
                if (!this.model.ad.video_ids_local || this.model.ad.video_ids_local.length === 0) {
                    return this.$message.error('请选择本地视频素材')
                }
            } else if (this.material_type === 3) {
                if (!this.model.ad.video_ids_rank || this.model.ad.video_ids_rank.length === 0) {
                    return this.$message.error('请选择视频排行素材')
                }
            } else if (this.material_type === 4) {
                if (!this.model.ad.video_ids_org || this.model.ad.video_ids_org.length === 0) {
                    return this.$message.error('请选择组织素材')
                }
            }
            return true
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善所有必填表单项！')
                    return
                }
                if (this.validateBeforeSubmit() !== true) {
                    return
                }

                const advertiserIds = this.model.ids || []
                if (advertiserIds.length > 0) {
                    this.loading = true
                    verifyMediaCorporations({ ids: advertiserIds }).then(res => {
                        this.loading = false
                        if (res.data && res.data.has_drift === true) {
                            const driftList = res.data.list || []
                            let message = '检测到以下广告主的媒体主体漂移：\n'
                            driftList.forEach(item => {
                                message += `${item.advertiser_name} (ID: ${item.advertiser_id})\n`
                            })
                            message += '\n请先处理媒体主体漂移问题后再继续创建任务。'
                            this.$modal.error({
                                title: '漂移媒体主体检测',
                                content: message,
                                okText: '知道了'
                            })
                            return
                        }
                        this.doSubmit()
                    }).catch(() => {
                        this.loading = false
                        this.doSubmit()
                    })
                    return
                }

                this.doSubmit()
            })
        },
        doSubmit() {
            this.inputLimit()
            this.roiVerify()

            if (this.model.ad.video_ids) {
                let materialErr = 0;
                this.model.ad.video_ids.forEach(element => {
                    if (element.url == '素材所属主体与开发者主体不一致无法获取URL' || element.poster_url == '素材所属主体与开发者主体不一致无法获取URL') {
                        materialErr++
                    }
                });
                if (materialErr>0) {
                    this.$message.error('请重新授权并勾选敏感物料权限！')
                    return false
                }
            }

            // console.log(this.model)
            this.$message.destroy()
            for (const key in this.advs) {
                const adv = this.advs[key]
                if (this.model.micro_promotion_type === 'BYTE_APP') {
                    if (!adv.micro_app_instance_id) {
                        return this.$message.error(`请关联广告主[${adv.name}]字节小程序`)
                    }
                    if (!adv.micro_app_url) {
                        return this.$message.error(`请关联广告主[${adv.name}]字节小程序链接`)
                    }
                    if (!adv.event_assets_id) {
                        return this.$message.error(`请关联广告主[${adv.name}]事件资产`)
                    }
                    // if (!adv.external_action) {
                    //     return this.$message.error(`请关联广告主[${adv.name}]优化目标`)
                    // }
                    if (!adv.external_url) {
                        return this.$message.error(`请关联广告主[${adv.name}]落地页`)
                    }
                    // 这里将提交过来的adv.external_url，塞入addUniqueExternalUrl并去重
                    this.addUniqueExternalUrl(adv.external_url)
                } else if (this.model.micro_promotion_type === 'AWEME') {
                    if (!adv.video_url) {
                        return this.$message.error(`请关联广告主[${adv.name}]短剧专辑链接`)
                    }
                    this.addUniqueVideoUrl(adv.video_url)
                } else {
                    if (this.model.ad.native_setting.anchor_related_type == 'SELECT' && !adv.anchor_id) {
                        return this.$message.error(`请关联广告主[${adv.name}]锚点`)
                    }
                    if (!adv.micro_app_instance_id) {
                        return this.$message.error(`请关联广告主[${adv.name}]微信小程序（可通过【同步锚点-落地页-小程序】按钮获取）`)
                    }
                    if (!adv.external_url) {
                        return this.$message.error(`请关联广告主[${adv.name}]落地页`)
                    }
                    // 这里将提交过来的adv.external_url，塞入addUniqueExternalUrl并去重
                    this.addUniqueExternalUrl(adv.external_url)
                }
            }

            if (this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.budget<100) {
                return this.$message.error('请填写正确的项目日预算')
            }

            if (this.model.delivery_mode === 'MANUAL' && this.model.delivery_setting.budget_mode === 'BUDGET_MODE_DAY' && this.model.delivery_setting.budget<300) {
                return this.$message.error('请填写正确的项目预算')
            }

           
            if (this.model.ad.budget < this.adBudget) {
                this.model.ad.budget = this.adBudget
            }
            // return false;
            this.storeOrUpdate()
        },
      
        storeOrUpdate() {
            this.loading = true
            let json = Object.assign({}, this.model)
            json.advs = this.advs
            json.advertisers = this.advertisers

            // 内广开关关闭时，不传 classify 字段
            if (!json.classify) {
                delete json.classify
            }

            let awemeIds = this.model.ad.native_setting.aweme_id
            if (!Array.isArray(awemeIds)) {
                awemeIds = String(awemeIds).split(',').map(id => id.trim()).filter(Boolean)
            }
            json.ad.awemes = this.awemes.filter(a => awemeIds.includes(String(a.id)))
            
            if (json.audience.district === 'REGION') {
                json.audience.city = NoBSGS
                json.audience.location_type = 'CURRENT'
                json.audience.region_version = '1.0.0'
            }
            json.material_type = this.material_type

            if (this.model.delivery_setting.schedule_time_type==2) {
                json.delivery_setting.final_schedule_time = this.convertTimeSchedule(json.delivery_setting.schedule_time)
            }
            if (this.model.delivery_setting.schedule_type=='SCHEDULE_START_END') {
                json.delivery_setting.start_time = json.delivery_setting.schedule_date[0]
                json.delivery_setting.end_time = json.delivery_setting.schedule_date[1]
            }
            // 当手动模式 && 项目预算选择的是不限的时候 需要删除项目预算this.model.delivery_setting.budget
            if (this.model.delivery_mode === 'MANUAL' && this.model.delivery_setting.budget_mode === 'BUDGET_MODE_INFINITE') {
                delete this.model.delivery_setting.budget
            }
            // console.log('最终提交的数据', json)
            storeOrUpdateAdTask(this.media, json).then(() => {
                this.current = 3 // 直接跳转到结果页
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            this.loading = false
        },
        convertTimeSchedule(input) {
            // 初始化每周7天，每天48个区段，默认全为 "0"
            const weekSchedule = Array(7).fill().map(() => Array(48).fill('0'));
          
            // 遍历输入数组，设置对应时间段为 "1"
            input.forEach((daySchedule, dayIndex) => {
              if (daySchedule && Array.isArray(daySchedule)) {
                daySchedule.forEach(timeSlot => {
                  weekSchedule[dayIndex][timeSlot] = '1';
                });
              }
            });
          
            // 拼接7天的结果为一个字符串
            return weekSchedule.map(day => day.join('')).join('');
        },
        doTask(taskId, advIndex) {
            this.loading = true
            const json = {
                id: taskId,
                advertiser_id: this.model.ids[advIndex]
            }
            storeOrUpdateAdTask(this.media, json).then(res => {
                this.result.success = this.result.success.concat(res.data.success || [])
                this.result.errors = this.result.errors.concat(res.data.errors || [])
            }).catch(() => {})
        },
        close() {
            this.$emit('success')
            this.$emit('update:showCreateForm', false)
        },
        changeBidType(e) {
            if (e.target.value === 'NO_BID') {
                this.model.search_bid_ratio = null
            }
        },
        changeAge(v) {
            this.changeHandle(v, 'age', 'BUDGET_MODE_INFINITE')
        },
        changePlatform(v) {
            this.changeHandle(v, 'platform', '')
        },
        changeHandle(v, field, noneId) {
            if (v.length <= 1) {
                return true
            }
            if (v[v.length - 1] === noneId) {
                this.model.audience[field] = [noneId]
                return true
            }
            this.model.audience[field] = this.model.audience[field].filter(item => {
                return item !== noneId
            })
        },
        changeProduct() {
            this.productDetails = {}
            // delete this.model.related_product.product_id
            this.model.related_product.product_id = ''
            this.getProductDetails()
        },
        getProductDetails(adv_id, product_platform_id, flag=null, product_id='') {
            const json = {
                advertiser_id: adv_id,
                product_platform_id: product_platform_id,
                flag:flag
            }
            this.loading = true
            getProductDetails(json).then(res => {
                let thisList = res.data.list || []
                const adv = this.advs[adv_id] || []
                if (this.model.product_model === 1) {
                    // 商品库统一设置
                    if (adv.pt && adv.pt.video_name) {
                        const videoName = adv.pt.video_name
                        thisList.forEach(item => {
                            if (item.name === videoName) {
                                this.model.related_product.product_id = item.id
                            }
                        })
                    } else {
                        this.model.related_product.product_id = product_id
                    }
                } else {
                    // 商品库分别设置
                    if (adv.pt && adv.pt.video_name) {
                        let targetAdvertiser = this.advertisers.find(ad => ad.advertiser_id === adv.out_id)

                        if (targetAdvertiser) {
                            if (adv.pt && adv.pt.video_name) {
                              const videoName = adv.pt.video_name
                            //   console.log('videoName', videoName)
                              const targetItem = thisList.find(item => item.name === videoName)
                              if (targetItem) {
                                targetAdvertiser.product_id = targetItem.id
                              } else if (product_id) {
                                targetAdvertiser.product_id = product_id
                              }
                            } else if (product_id) {
                                // console.log('product_id', product_id)
                                targetAdvertiser.product_id = product_id
                            }
                        }

                        // const videoName = adv.pt.video_name
                        // thisList.forEach(item => {
                        //     if (item.name === videoName) {
                        //         // console.log('videoName', videoName)
                        //         if (targetAdvertiser) {
                        //             targetAdvertiser.product_id = item.id
                        //         }
                        //     }
                        //     if (product_id) {
                        //         if (targetAdvertiser) {
                        //             targetAdvertiser.product_id = product_id
                        //         }
                        //     }
                        // })
                    } else {
                        let targetAdvertiser = this.advertisers.find(ad => ad.advertiser_id === adv.out_id)
                        if (targetAdvertiser) {
                            // console.log('product_id2', product_id)
                            targetAdvertiser.product_id = product_id
                        }
                    }
                }
                
                this.$set(this.productDetails, product_platform_id, thisList)
                // console.log('productDetailbbb', this.productDetails)
            }).finally(() => {
                this.loading = false
            })
        },
        // changeProductDetail(v, dom) {
        //     if (!dom || !dom.componentOptions || !dom.componentOptions.children || !dom.componentOptions.children[0]) {
        //         return
        //     }
        //     let title = dom.componentOptions.children[0].text.split('（ID')[0]
        //     this.model.ad.promotion_materials.product_info.titles = title.replace(/\s*/g, '')
        // },
        changeProductDetail(){},
        tabClass(adv) {
            if (this.model.micro_promotion_type === 'BYTE_APP') {
                if (!adv.micro_app_instance_id || !adv.micro_app_url || !adv.event_assets_id || !adv.external_url) {
                    return 'tab-danger'
                }
            } else if (this.model.micro_promotion_type === 'AWEME') {
                if (!adv.video_url) {
                    return 'tab-danger'
                }
            } else {
                if ( (this.model.ad.native_setting.anchor_related_type == 'SELECT' && !adv.anchor_id) || !adv.external_url) {
                    return 'tab-danger'
                }
            }
          
            return ''
        },
        deleteImage() {
            this.$nextTick(() => {
                this.model.ad.promotion_materials.product_info.image = null
            })
        },
        setTitleGroup(group) {
            this.$set(this.model.ad.promotion_materials, 'title_material_list', group.titles)
            this.$nextTick(() => {
                this.$refs.title_group.init()
            })
        },
        syncData(selectedIds = null) {
            let advIds = []
            if (Array.isArray(selectedIds) && selectedIds.length) {
                advIds = selectedIds
            } else {
                advIds = Object.values(this.advs).map(adv => adv.id)
            }
            // let advs = []
            // if (advId) {
            //     advs[advId] = this.advs[advId]
            // } else {
            //     advs = this.advs
            // }
            // for (const key in advs) {
            //     advIds.push(this.advs[key].id)
            // }
            const filters = { ids: advIds }
            const pullAnchorFn = () => { return pullAnchor(filters) }
            const pullUrlFn = () => {  return syncLandingPage(filters) }
          

            //同步事件资产
            const pullEventAssetFn = () => { 
                return pullEventAsset(filters) 
            }
            //同步字节小程序
            const pullAppFn = () => { 
                filters.type=this.model.micro_promotion_type === 'WECHAT_APP' ? 1 : 2;
                return pullWechatApp(filters) 
            }

            const refreshExt = () => {
                let advIdss = []
                advIdss = Object.values(this.advs).map(adv => adv.id)
                filters.ids = advIdss
                return getAdvertiserExts(filters).then(res => {
                    this.advs = res.data.list || []
                    this.selectedEventConfigs = []
                    this.selectedAppLinks = []
                    for (const key in this.advs) {
                        const adv = this.advs[key]
                        this.selectedEventConfigs[adv.out_id] = adv.event_configs
                        this.selectedAppLinks[adv.out_id] = adv.micro_app_links

                        // if (this.params && this.params.params && this.params.params.advs && this.params.params.advs[key]) {
                        //     const thisAd = this.params.params.advs[key]
                        //     if (thisAd.external_url && thisAd.external_url!=adv.external_url) {
                        //         adv.external_url = thisAd.external_url
                        //     }
                        // }
                        
                    }
                                            this.syncUrls(1)
                                        this.$message.success('关联数据同步完成')
                }).finally(() => {
                    this.syncLoading = false
                })
            }
            this.syncLoading = true

            if (this.model.micro_promotion_type === 'BYTE_APP') {
                pullEventAssetFn().finally(() => {
                    pullAppFn().finally(() => {
                        pullUrlFn().finally(() => {
                            refreshExt()
                        })
                    })
                })
            } else {
                pullAnchorFn().finally(() => {
                    pullAppFn().finally(() => {
                        pullUrlFn().finally(() => {
                            refreshExt()
                        })
                    })
                })
            }
          
        },
        changeEventAssent(adv) {
            let selectedItem = adv.event_assets.find(item => item.id === adv.event_assets_id);
            this.selectedEventConfigs[adv.out_id] = selectedItem.event_configs;
        },
        changeMicroApp(adv) {
            if (!adv.micro_app_instance_id) {
                this.selectedAppLinks[adv.out_id] = []
                adv.micro_app_url = ''
                for (const key in this.advs) {
                    if (adv.out_id === this.advs[key].out_id) {
                        this.advs[key].micro_app_url = ''
                    }
                }
                return
            }
        
            let selectedItem = adv.apps.find(item => item.id === adv.micro_app_instance_id);
            this.selectedAppLinks[adv.out_id] = selectedItem.links.length>0 ? selectedItem.links : [];
        },
        changeMicroPromotionType(e) {
            // console.log('radio checked', e.target.value);
            if (e.target.value === 'BYTE_APP') {
                this.model.ad.native_setting.anchor_related_type = 'AUTO'
                this.showProduct = true
                this.showInventoryType = false
            } else if (e.target.value === 'AWEME') {
                // 这里处理隐藏商品库关联信息
                this.showProduct = false
                this.showInventoryType = true
            } else {
                this.model.ad.native_setting.anchor_related_type = 'AUTO'
                this.showProduct = true
                this.showInventoryType = false
            }
            this.model.need_product = 1
            this.model.optimize_goal.deep_external_action = null
        },
        changeDeliveryMode(e) {
            this.model.optimize_goal.deep_external_action = null
            this.model.delivery_setting.bid_type = null
            this.model.audience.interest_action_mode = 'UNLIMITED'
            if (e.target.value === 'PROCEDURAL') {
                this.model.delivery_setting.budget_mode = 'BUDGET_MODE_DAY'
            } else {
                this.model.delivery_setting.budget_mode = 'BUDGET_MODE_INFINITE'
            }
          
            if (this.model.delivery_mode === 'PROCEDURAL') {
                this.model.need_product = 1 //开始产品库
            }
        },
        materialTypeChange(key) {
            this.model.material_type = key
            this.material_type = key
        },
        changeVideo(item){
            this.model.ad.video_ids_local = item
        },
        showModal() {
            this.visible = true;
        },
        handleCancel() {
            this.visible = false;
        },
        changeLdyUrl() {
            // console.log('进入', this.adv.external_url)

            this.adv.external_ur = this.select_ldy_url
        },
        changeExternalAction () {
            // console.log('aaa',this.model)
            this.model.optimize_goal.deep_external_action = null

            // 清除之前的规则
            this.$delete(this.rules, 'optimize_goal.deep_external_action');
            // let firstAdv = this.advs[this.model.ids[0]]

            // console.log('aaa', firstAdv, this.model.ids, this.advs)
            if (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE') {
                //如果广告主第一个是iaa,那么 深度优化目标 为必填
                let firstAdv = this.advs[this.model.ids[0]]
                if (firstAdv) {
                    this.model.optimize_goal.deep_external_action = 'AD_CONVERT_TYPE_LT_ROI'
                    this.$set(this.rules, `optimize_goal.deep_external_action`, [{ 
                        required: true, 
                        message: '请选择深度优化目标', 
                        trigger: 'change' 
                    }]);
                } 
            }
        },
        inputLimit() {
            let thisMax
            let thisMin

            //手动，最大转化， 择优分配不启用， 广告预算最大500，
            //手动，最大转化， 择优分配启用， 项目预算最大500，
            //自动，最大转化， 项目预算最大500，

            if (this.model.delivery_setting.budget) {
                if (this.model.delivery_mode === 'PROCEDURAL') {
                    thisMax = this.model.delivery_setting.bid_type === 'NO_BID' ? 500 : 999999
                } else {
                    thisMax = this.model.delivery_setting.bid_type === 'NO_BID' && this.model.delivery_setting.budget_optimize_switch ==='ON' ? 500 : 999999
                }
                if (this.model.delivery_setting.budget>thisMax) {
                    this.model.delivery_setting.budget = thisMax
                }
            }
            if (this.model.ad.budget) {
                thisMax = this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type === 'NO_BID' && this.model.delivery_setting.budget_optimize_switch ==='OFF' ? 500 : 999999
                if (this.model.ad.budget>thisMax) {
                    this.model.ad.budget = thisMax
                }
                thisMin = this.adBudget
                if (this.model.ad.budget<thisMin) {
                    this.model.ad.budget = thisMin
                }
            }

            if (this.model.cpa_bid) {
                thisMax = this.bid_limit ? this.bid_limit : 10
                if (this.model.cpa_bid>thisMax) {
                    this.model.cpa_bid = thisMax
                }
            }

            if (this.model.ad.bid) {
                thisMax = this.bid_limit ? this.bid_limit : 10
                if (this.model.ad.bid>thisMax) {
                    this.model.ad.bid = thisMax
                }
            }
            
            // 代码勿删，暂时提交不修改ROI系数，只验证ROI系数是否小于兜底值
            // if (this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && this.model.optimize_goal.deep_external_action) {
            //     thisMin = this.getRoiMin()
            //     if (this.model.roi_goal_model === 1) {
            //         if (this.model.roi_goal<thisMin) {
            //             this.model.roi_goal = thisMin
            //         }
            //     } else {
            //         this.advertisers = this.advertisers.map(advertiser => {
            //             if (advertiser.roi_goal < thisMin) {
            //                 return {
            //                     ...advertiser,
            //                     roi_goal: thisMin
            //                 }
            //             }
            //             return advertiser
            //         })
            //     }
            // }

            // if (this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && ( (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))) {
            //     thisMin = this.getRoiMin()
            //     if (this.model.ad.roi_goal_model === 1) {
            //         if (this.model.ad.roi_goal<thisMin) {
            //             this.model.ad.roi_goal = thisMin
            //         }
            //     } else {
            //         this.advertisers = this.advertisers.map(advertiser => {
            //             if (advertiser.ad.roi_goal < thisMin) {
            //                 return {
            //                     ...advertiser,
            //                     ad: {
            //                         ...advertiser.ad,
            //                         roi_goal: thisMin
            //                     }
            //                 }
            //             }
            //             return advertiser
            //         })
            //     }
            // }
        },
        changeDeepExternalAction () {
            //如果取消了，
            if (!this.model.optimize_goal.deep_external_action) {
                this.model.delivery_setting.deep_bid_type = null
            } else {
                this.model.delivery_setting.deep_bid_type = 'ROI_COEFFICIENT'
            }
        }, 
        jumpFirst () {
            this.current = 0
            //清除项目出价
            if (this.model.cpa_bid) {
                this.model.cpa_bid = null
            }
       
            //清除广告出价
            if (this.model.ad.bid) {
                this.model.ad.bid = null
            }
            // this.model.related_product.product_platform_id = null
            // this.model.related_product.product_id = null
            const timeStr = moment().format('_MM_DD_HH:mm:ss')
            const timePattern = /_\d{2}_\d{2}_\d{2}:\d{2}:\d{2}$/  // 匹配 _11_22_14:24:18 这种格式
            if (this.model.name) {
                if (timePattern.test(this.model.name)) {
                    // 已有时间 → 替换
                    this.model.name = this.model.name.replace(timePattern, timeStr)
                } else {
                    // 没时间 → 拼上时间
                    this.model.name += timeStr
                }
            } else {
                this.model.name = '小程序项目' + timeStr
            }
            this.syncAdName()
            // console.log('this.model.name', this.model.name)
            // console.log('this.model.ad.name', this.model.ad.name)
        },
        disabledDate(current) {
            // 禁止选择小于今天的日期
            return current && moment(current).isBefore(moment().startOf('day'));
        },
        addUniqueExternalUrl(url) {
            if (url && !this.externalUrls.includes(url)) {
              this.externalUrls.push(url)
            }
        },
        addUniqueVideoUrl(url) {
            if (url && !this.videoUrls.includes(url)) {
              this.videoUrls.push(url)
            }
        },
        changeProductModel () {
            if (this.model.product_model === 2) {
                this.model.cpa_bid_model = 2
                this.model.roi_goal_model = 2
                this.model.ad.bid_model = 2
                this.model.ad.roi_goal_model = 2
                if (this.advertisers.length > 0) {
                    let adv_id = this.advertisers[0].id
                    //如果商品库没有第一个，重新获取第一个
                    if(!this.products[adv_id]){
                        this.refreshProducts(adv_id)
                    }
                    // 切换商品库模式-分别设置时，默认选中第一个广告主
                    this.activeTabKey = adv_id
                }
            }
        },
        clickPane (activeKey) {
            if (this.model.product_model === 2) {
                let adv_id = this.advertisers[activeKey].id
                let product_platform_id = this.advertisers[activeKey].product_platform_id
                let product_id = this.advertisers[activeKey].product_id
                //如果商品库没有，重新获取
                if(!this.products[adv_id]){
                    this.refreshProducts(adv_id, product_platform_id, product_id)
                } 
                this.activeTabKey = adv_id
            }
        },
        changeLibrary(product_platform_id, option) {
            if (option === undefined || option === null) {
                return;
            }
            let adv_id = option.data.attrs.adv_id ?? null
            console.log('切换商品库', product_platform_id, option );

            if (!adv_id) {
                adv_id = this.model.ids[0]
                // delete this.model.related_product.product_id
                this.model.related_product.product_id = ''
            } else {
                if (this.model.product_model === 2) {
                    let advertiserObj = this.advertisers.find(ad => ad.id === adv_id)
                    advertiserObj.product_id = ''
                }
            }
          
            this.productDetails = {}
            this.getProductDetails(adv_id, product_platform_id)
        },
        addUniqueAdvertisers(advertiser) {
            if (advertiser.id && !this.advertisers.some(item => item.id === advertiser.id)) {
                this.advertisers.push(advertiser)
            }
            // 按照 this.model.ids 的顺序排序
            this.advertisers.sort((a, b) => {
                const indexA = this.model.ids.indexOf(a.id)
                const indexB = this.model.ids.indexOf(b.id)
                return indexA - indexB
            })
        },
        generateRules() {
            // 为每个 advertisers 动态生成规则
            this.advertisers.forEach((_, index) => {
              this.$set(this.rules, `advertisers.${index}.bid`, [{ required: true, message: '请填写广告出价', trigger: 'change' }]);
            });

            // console.log('合并后：',this.rules)
        },
        renderTab(advertiser, type='product') {
            let isGreen = false
            if (type === 'product') {
                isGreen = !!advertiser.product_platform_id && !!advertiser.product_id;
            } else if (type === 'ad_bid') {
                isGreen = !!advertiser.bid
            } else if (type === 'ad_roi_goal') {
                isGreen = !!advertiser.ad.roi_goal
            } else if (type === 'cpa_bid') {
                isGreen = !!advertiser.cpa_bid
            } else if (type === 'roi_goal') {
                isGreen = !!advertiser.roi_goal
            } else if (type === 'project_name') {
                isGreen = !!advertiser.project_name
            } else if (type === 'ad_name') {
                isGreen = !!advertiser.ad.ad_name
            } else if (type === 'source') {
                isGreen = !!advertiser.ad.source
            }
            const isActive = advertiser.id === this.activeTabKey
            const color = isActive ? 'black' : isGreen ? 'green' : 'red'
            
            return (
              <a-tooltip title={advertiser.name} placement="right">
                <span class="adv-tab-name" style={`color: ${color}`}>
                  {advertiser.name}
                </span>
              </a-tooltip>
            )
        },
        changeAdvertiser(adv_id) {
            if (adv_id) {
                this.currentAdvId = adv_id
            } else {
                this.currentAdvId = this.model.ids[0] 
            }
        },
        syncAdName() {
            const name = this.model.name
            if (!name) {
                this.model.ad.name = ''
                return
            }
            const timePattern = /_\d{2}_\d{2}_\d{2}:\d{2}:\d{2}$/
            if (timePattern.test(name)) {
                this.model.ad.name = name.replace(timePattern, (match) => '_广告' + match)
            } else {
                this.model.ad.name = name + '_广告'
            }
        },
        getRoiMin(advertiser) {
            // 如果有 advertiser（分别设置模式）
            if (advertiser) {
                for (const [prefix, val] of Object.entries(this.kvDatas)) {
                    if (advertiser.name.startsWith(prefix)) {
                        return val
                    }
                }
                return this.getDefaultRoiMin()
            }

            // 统一设置 → 默认取第一个广告主
            const firstAdv = this.advertisers?.[0]
            if (firstAdv) {
                for (const [prefix, val] of Object.entries(this.kvDatas)) {
                    if (firstAdv.name.startsWith(prefix)) {
                        return val
                    }
                }
            }
            return this.getDefaultRoiMin()
        },
        getDefaultRoiMin() {
            if (
                this.model.micro_promotion_type !== 'AWEME' &&
                this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE' &&
                this.model.optimize_goal.deep_external_action === 'AD_CONVERT_TYPE_LT_ROI'
            ) {
                return this.roiDefaultLimits.active_roi || 0.76
            } else if (
                this.model.micro_promotion_type !== 'AWEME' &&
                this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' &&
                this.model.optimize_goal.deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI'
            ) {
                return this.roiDefaultLimits.pay_roi || 1
            } else if (this.model.micro_promotion_type === 'AWEME') {
                return this.roiDefaultLimits.aweme || 0.8
            }
            return 1
        },
        syncUrls(type = 1) {
            let field = type === 2 ? 'video_url' : 'external_url';
            let message = type === 2 ? '批量设置短剧专辑链接为空时，不可同步！' : '批量设置备用网页链接(落地页)为空时，不可同步！';
            let batchField = 'batch_' + field;
            // 检查 batch_external_url 是否存在
            if (this[batchField]) {
                // 遍历 advs，将 batch_external_url 填充到每个 adv.external_url
                Object.keys(this.advs).forEach(key => {
                    this.advs[key][field] = this[batchField]
                })
                //  console.log('this.advs', this.advs)
                return this.$message.success('同步成功')
            } else {
                return this.$message.error(message)
                // 如果 batch_external_url 为空，清空每个 adv.external_url
                // Object.keys(this.advs).forEach(key => {
                //     this.advs[key].external_url = ''
                // })
            }
        },
        getAwemeId(advertiserFilter) {
            if (this.model.ad.generate_mode) {
                // 启用生成模式
                getAwemes(advertiserFilter).then(res => {
                    this.awemes = (res.data.list || []).filter((a, i, arr) => arr.findIndex(b => b.id === a.id) === i)
                })
            } else {
                // 查询第一个广告主信息
                getAdvertiserInfo(advertiserFilter).then(res => {
                    this.advertiserInfo = res.data || {}
                    // 获取抖音号数据
                    getAwemes(advertiserFilter).then(res => {
                        this.awemes = (res.data.list || []).filter((a, i, arr) => arr.findIndex(b => b.id === a.id) === i)
                        let found = false
                        for (const aweme of this.awemes) {
                            if (aweme.id === this.advertiserInfo.aweme_id) {
                                this.model.ad.native_setting.aweme_id = aweme.id
                                found = true
                                break
                            }
                        }
                        // 如果未找到匹配的 id，执行默认逻辑
                        if (!found && this.awemes.length > 0) {
                            this.model.ad.native_setting.aweme_id = this.awemes[this.awemes.length - 1].id
                        }
                    })
                })
            }
        },
        setBatchCpaBid() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []

                let successCount = 0

                for (const key in this.advs) {
                    const adv = this.advs[key]
                    
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    // 是否匹配到对应广告主
                    if (existingAdvertiser) {
                        // 查询复制过来的数据是否存在当前广告主，存在则取复制过来的项目出价
                        const existingAdvertiser2 = this.model.advertisers.find(item => item.id === adv.id)

                        const newBid = existingAdvertiser2 && existingAdvertiser2.cpa_bid 
                            ? existingAdvertiser2.cpa_bid 
                            : adv.bid_limit || null
                        if (newBid !== null) {
                            // 修改 cpa_bid 值
                            existingAdvertiser.cpa_bid = newBid
                            successCount++ // 成功计数
                        }
                    }
                }
                return this.$message.success(`成功设置出价的广告主数量: ${successCount}`)
            })
        },
        setBatchBid() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []

                let successCount = 0

                for (const key in this.advs) {
                    const adv = this.advs[key]
                    
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    // 是否匹配到对应广告主
                    if (existingAdvertiser) {
                        // 查询复制过来的数据是否存在当前广告主，存在则取复制过来的广告出价
                        const existingAdvertiser2 = this.model.advertisers.find(item => item.id === adv.id)
                        
                        const newBid = existingAdvertiser2 && existingAdvertiser2.bid 
                            ? existingAdvertiser2.bid 
                            : adv.bid_limit || null
                        if (newBid !== null) {
                            // 修改 cpa_bid 值
                            existingAdvertiser.bid = newBid
                            successCount++ // 成功计数
                        }
                    }
                }
                return this.$message.success(`成功设置出价的广告主数量: ${successCount}`)
            })
        },
        setBatchSource() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []

                let successCount = 0

                for (const key in this.advs) {
                    const adv = this.advs[key]
                    
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    // 是否匹配到对应广告主
                    if (existingAdvertiser) {
                        // 查询复制过来的数据是否存在当前广告主，存在则取复制过来的广告来源
                        const existingAdvertiser2 = this.model.advertisers.find(item => item.id === adv.id)
                        
                        const newSource = existingAdvertiser2 && existingAdvertiser2.ad.source 
                            ? existingAdvertiser2.ad.source 
                            : adv.source || null
                        if (newSource !== null) {
                            // 修改 cpa_bid 值
                            existingAdvertiser.ad.source = newSource
                            successCount++ // 成功计数
                        }
                    }
                }
                return this.$message.success(`成功设置来源的广告主数量: ${successCount}`)
            })
        },
        setBatchProduct() {
            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                this.advs = res.data.list || []

                let successCount = 0

                for (const key in this.advs) {
                    const adv = this.advs[key]
                    
                    const existingAdvertiser = this.advertisers.find(item => item.id === adv.id)
                    // 是否匹配到对应广告主
                    if (existingAdvertiser) {
                        const productPlatformId = adv.product_platform_id || null
                        const productId = adv.product_id || null
                        if (productPlatformId !== null) {
                            // 清空 product_id
                            existingAdvertiser.product_id = null
                            // 修改 商品库ID
                            existingAdvertiser.product_platform_id = productPlatformId
                            successCount++ // 成功计数
                            this.getProductDetails(adv.id, productPlatformId, null, productId)
                        }
                    }
                }
                return this.$message.success(`成功设置商品库数量: ${successCount}`)
            })
        },
        roiVerify() {
            let thisMin
            // 项目ROI系数
            if (this.model.roi_goal_model === 2 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && this.model.optimize_goal.deep_external_action) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.roi_goal) {
                        return this.$message.error(`请填写广告主[${adv.name}]项目ROI系数`)
                    }
                    thisMin = this.getRoiMin(adv)
                    if (adv.roi_goal < thisMin) {
                        return this.$message.error(`广告主[${adv.name}]项目ROI系数不能低于${thisMin}`)
                    }
                }
            }
            if (this.model.roi_goal_model === 1 && this.model.delivery_mode === 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && this.model.optimize_goal.deep_external_action) {
                thisMin = this.getRoiMin()
                if (!this.model.roi_goal) {
                    return this.$message.error(`请填写统一设置项目ROI系数`)
                }
                if (this.model.roi_goal < thisMin) {
                    return this.$message.error(`统一设置项目ROI系数不能低于${thisMin}`)
                }
            }
            // 广告ROI系数
            if (this.model.ad.roi_goal_model === 2 && this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && ( (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.ad.roi_goal) {
                        return this.$message.error(`请选择广告主[${adv.name}]广告ROI系数`)
                    }
                    thisMin = this.getRoiMin(adv)
                    if (adv.ad.roi_goal < thisMin) {
                        return this.$message.error(`广告主[${adv.name}]广告ROI系数不能低于${thisMin}`)
                    }
                }
            }
            if (this.model.ad.roi_goal_model === 1 && this.model.delivery_mode != 'PROCEDURAL' && this.model.delivery_setting.bid_type != 'NO_BID' && ( (this.model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))) {
                thisMin = this.getRoiMin()
                if (!this.model.ad.roi_goal) {
                    return this.$message.error(`请填写统一广告ROI系数`)
                }
                if (this.model.ad.roi_goal < thisMin) {
                    return this.$message.error(`统一设置广告ROI系数不能低于${thisMin}`)
                }
            }
        },
        changeNewPlatform()
        {
            // 新增：切换平台清空防抖定时器
            if (this.searchTimer) clearTimeout(this.searchTimer)
            this.batch_video_url = ''
            this.searchKeyword = '' // 清空搜索关键词
            this.fetchVideos() // 重新加载当前平台的全部短剧
            // getPtFenxiaos({platform_id:platform_id}).then(res => { this.ptFenxiaos = res.data.list || {}  })
        },
        handleChange(values) {
            if (values.includes('all')) {
                const allIds = this.awemes.map(item => item.id)
                this.model.ad.native_setting.aweme_id = allIds
            }
            if (Array.isArray(this.model.ad.native_setting.aweme_id)) {
                const count = this.model.ad.native_setting.aweme_id.length
                // 当选择多个抖音号时，默认启用生成模式，默认主页始终可见
                if (count > 1) {
                    this.model.ad.generate_mode = true
                    this.model.ad.video_hp_visibility = 'ALWAYS_VISIBLE'
                } else {
                    this.model.ad.generate_mode = false
                    this.model.ad.video_hp_visibility = 'HIDE_VIDEO_ON_HP'
                }
            }
            this.modifyAdNum()
        },
        handleGenerateModeChange(checked) {
            this.model.ad.generate_mode = checked
            this.modifyAdNum()
        },
        handleClassifyChange(checked) {
            if (checked) {
                this.model.classify = 'CLASSIFY_INTERNAL'
            } else {
                this.model.classify = null
            }
        },
        modifyAdNum() {
            if (Array.isArray(this.model.ad.native_setting.aweme_id)) {
                const count = this.model.ad.native_setting.aweme_id.length
                if (count > 1 && this.model.ad.generate_mode) {
                    this.model.ad.num = count
                    this.maxAdNum = count
                    this.adNumHelp = '多抖音号+启用生成模式，最大广告数量不能超过'+count+'个'
                } else {
                    this.calcAdNum()
                }
            } else {
                this.calcAdNum()
            }
        },
        calcAdNum() {
            if (Array.isArray(this.model.ad.native_setting.aweme_id) && this.model.ad.native_setting.aweme_id.length > 1 && this.model.ad.generate_mode) {
                return
            }
            const materialNum = this.model.ad.material_num || 1
            const videoCount = this.currentVideoCount
            if (videoCount > 0) {
                this.model.ad.num = Math.min(Math.ceil(videoCount / materialNum), 10)
            } else {
                this.model.ad.num = 1
            }
            this.maxAdNum = 10
            this.adNumHelp = '根据已选素材数量和每个广告素材数量自动计算，最大不能超过10个'
        },
        toggleSelect(id) {
            const index = this.selectedAdvIds.indexOf(id)
            if (index === -1) {
                this.selectedAdvIds.push(id)
            } else {
                this.selectedAdvIds.splice(index, 1)
            }
        },
        syncMultiple() {
            if (!this.selectedAdvIds.length) {
                return this.$message.warning('请至少选择一个广告主')
            }
            
            this.syncData(this.selectedAdvIds)
        },
        // upload() {
        //     this.showUploadForm = true
        // },
        validateForm() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }

                // console.log(this.model);
                if (this.mediaCorporationCheck(1) && this.model.optimize_goal.deep_external_action != 'AD_CONVERT_TYPE_PURCHASE_ROI') {
                    return this.$message.error("当前主体深度优化目标必须选择付费roi！")
                }

                if (this.mediaCorporationCheck(2) && this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action != 'AD_CONVERT_TYPE_LT_ROI') {
                    return this.$message.error("当前主体深度优化目标必须选择广告变现ROI！")
                }

                //如果当前选择了激活，一定要选择广告变现ROI
                if (this.model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && this.model.optimize_goal.deep_external_action != 'AD_CONVERT_TYPE_LT_ROI') {
                    return this.$message.error("当前选择了激活，一定要选择广告变现ROI！")
                }

                if (this.model.delivery_mode === 'PROCEDURAL' && (this.model.delivery_setting.budget < 100 || this.model.delivery_setting.budget === undefined)) {
                    this.$message.error('请填写正确的项目日预算')
                    return false
                }

                if (this.model.delivery_mode === 'MANUAL' && this.model.delivery_setting.budget_mode === 'BUDGET_MODE_DAY' && (this.model.delivery_setting.budget < 300 || this.model.delivery_setting.budget === undefined)) {
                    this.$message.error('请填写正确的项目预算')
                    return false
                }

                if (this.model.delivery_setting.schedule_type == 'SCHEDULE_START_END') {
                    if (this.model.delivery_setting.schedule_date.length<2) {
                        this.$message.error('请选择投放开始和结束时间')
                        return false
                    }

                    if (this.model.delivery_setting.schedule_date[0] > this.model.delivery_setting.schedule_date[1]) {
                        this.$message.error('投放开始时间不能大于结束时间')
                        return false
                    }
                    //如果投放开始时间小于今天，报错
                    if (this.model.delivery_setting.schedule_date[0] < moment().format('YYYY-MM-DD')) {
                        this.$message.error('投放开始时间不能小于今天')
                        return false
                    }
                }

                if (this.model.delivery_mode == "MANUAL" && this.model.delivery_setting.bid_type == "NO_BID" && this.model.delivery_setting.budget_optimize_switch == "OFF") {
                    this.adBudget = 100
                    // this.model.ad.budget = this.adBudget
                } else {
                    this.adBudget = 300
                }

                if (this.current ==1 && this.model.ad.video_ids) {
                    let materialErr = 0;
                    this.model.ad.video_ids.forEach(element => {
                        if (element.url == '素材所属主体与开发者主体不一致无法获取URL' || element.poster_url == '素材所属主体与开发者主体不一致无法获取URL') {
                            materialErr++
                        }
                    });
                    if (materialErr>0) {
                        this.$message.error('请重新授权并勾选敏感物料权限！')
                        return false
                    }
                }

                // if (this.current == 0 && this.model.micro_promotion_type != 'AWEME') {
                if (this.current == 0 && this.model.need_product == 1) {
                    //开始验证商品库和商品是否匹配的上
                    // console.log('商品库和商品', this.model.related_product.product_platform_id, this.model.related_product.product_id)
                  
                    this.loading = true

                    if (this.model.product_model == 1) {
                        getProductDetails({
                            advertiser_id: this.model.ids[0],
                            product_platform_id: this.model.related_product.product_platform_id,
                            product_id: this.model.related_product.product_id
                        }).then(res => {
                            // console.log('校验商品和商品库',res)
                            if (res.data.list.length>0) {
                                this.current++
                            } else {
                                this.loading = false
                                // this.$message.error('商品库和商品不匹配，请重新选择')
    
                                this.$notification.error({
                                    message: '商品库和商品不匹配',
                                    description: '商品库和商品不匹配，请重新选择',
                                    placement: 'bottomRight' // 设置通知位置为右下角
                                });
                                return false
                            }
                        }).finally(() => {
                            this.loading = false
                        })
                    } else {
                        // 遍历所有广告主，生成调用 getProductDetails 的 promise 数组
                        const detailPromises = this.advertisers.map(advertiser => {
                            return getProductDetails({
                                advertiser_id: advertiser.id,
                                product_platform_id: advertiser.product_platform_id,
                                product_id: advertiser.product_id
                            })
                        })
                        Promise.all(detailPromises).then(results => {
                            // 假设我们要求所有请求返回的数据列表都不为空，才认为验证通过
                            const allValid = results.every(res => res.data.list && res.data.list.length > 0)
                            if (allValid) {
                                this.current++
                            } else {
                                this.$notification.error({
                                    message: '商品库和商品不匹配',
                                    description: '有广告主对应的商品库和商品不匹配，请重新选择',
                                    placement: 'bottomRight'
                                })
                            }
                        }).catch(error => {
                            console.error('验证错误：', error)
                            this.$notification.error({
                                message: '校验错误',
                                description: '校验过程中出现错误，请重试',
                                placement: 'bottomRight'
                            })
                        })
                        .finally(() => {
                            this.loading = false
                        });
                    }

                } else {
                    this.current++
                }
              

            })
        },
        handleSearchVideo(query) {
            // 1. 未选择平台 → 不请求
            if (!this.model.platform_id) {
                this.ptFenxiaos = []
                return
            }

            // 2. 搜索词为空 → 清空列表+定时器，不请求接口（你要加的核心逻辑）
            if (!query || query.trim() === '') {
                clearTimeout(this.searchTimer);
                this.searchKeyword = '';
                return;
            }

            this.searchKeyword = query

            // 3. 防抖核心：清除上一次的定时器
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
            }

            // 4. 输入停止 300ms 后再请求接口
            this.searchTimer = setTimeout(() => {
                this.fetchVideos()
            }, 300) // 300ms 是最优延迟，可自行调整
        },
        fetchVideos() {
            this.videoLoading = true
            getPtFenxiaos({
                platform_id: this.model.platform_id,
                keyword: this.searchKeyword,
            }).then(res => {
                this.ptFenxiaos = res.data.list || []
            }).finally(() => {
                this.videoLoading = false
            })
        },

    }
}
